import { MsGraphQueries } from "@/api/msGraph/queries"
import { useQuery } from "@/api/utils/useQuery"
import { ProfileParser } from "@/models/profile/profile.parser"

class ProfileServiceClass {
  requestUserProfile() {
    return useQuery({
      ...MsGraphQueries.account.me(),
      parserFn: (data) => {
        return ProfileParser.toDomain(data)
      },
    })
  }
}

export const ProfileService = new ProfileServiceClass()
